export const HOME_URL = '/';

export const CREATE_HEARING_URL = '/hearing/new';
export const CURRENT_HEARINGS_URL = '/hearings/current';
export const MY_HEARINGS_WROTE_URL = '/hearings/mine/wrote';
export const MY_HEARINGS_ANSWERED_URL = '/hearings/mine/answered';
export const MY_HEARINGS_REVIEWER_URL = '/hearings/mine/reviewer';
export const MY_HEARINGS_INVITED_URL = '/hearings/mine/invited';
export const FINALIZED_HEARINGS_URL = '/hearings/final';
export const HEARING_DETAILS_URL = '/hearing/:id';
export const HEARING_URL = '/hearing/';

export const ADMIN_HOME_URL = '/admin';
export const ADMIN_CITYAREA_URL = '/admin/cityarea';
export const ADMIN_SUBJECTAREA_URL = '/admin/subjectarea';
export const ADMIN_GLOBAL_CONTENT_URL = '/admin/globalcontent';
export const ADMIN_HEARINGTYPE_URL = '/admin/hearingtype';
export const ADMIN_KLE_URL = '/admin/kle';
export const ADMIN_FIELDTEMPLATES_URL = '/admin/fieldtemplates';
export const ADMIN_INVITATIONGROUPS_URL = '/admin/invitationGroups';
